'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Mixins$FormBuilder = require("./styles/Mixins.bs.js");
var FormBuilder$FormBuilder = require("./FormBuilder.bs.js");
var FormPreview$FormBuilder = require("./FormPreview.bs.js");

function App(Props) {
  return React.createElement("main", {
              className: Curry._1(Css.merge, {
                    hd: Mixins$FormBuilder.flex_start_stretch,
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.height({
                                  NAME: "vh",
                                  VAL: 100
                                }),
                            tl: {
                              hd: Css.media("(max-width: 780px)", {
                                    hd: Css.height("auto"),
                                    tl: {
                                      hd: Css.flexDirection("column"),
                                      tl: /* [] */0
                                    }
                                  }),
                              tl: /* [] */0
                            }
                          }),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(FormBuilder$FormBuilder.make, {}), React.createElement(FormPreview$FormBuilder.make, {}));
}

var make = App;

exports.make = make;
/* Css Not a pure module */
